// ---------------------------------------------------------------------------
// Central de controle (cockpit de uso) — o lado do APARELHO. (Etapa C, v129)
//
// O que e': um registro de COMO o app e' usado — telas abertas, janelas, etapas dos
// assistentes (funis), botoes importantes, avisos e erros. Vai direto para o nosso
// Supabase (funcao registrar_uso, sql/central_uso.sql), sem empresa de fora: nada de
// Google Analytics/PostHog. Quem e' a pessoa o BANCO descobre pelo login (JWT); daqui
// nunca sai nome, telefone, e-mail, valor digitado nem texto livre — so' codigos.
//
// Regras de ouro (o cockpit nunca pode quebrar o app):
//  * toda chamada e' "dispara e esquece": dentro de try/catch, sem await no caminho do usuario;
//  * nada roda no render — so' em efeito ou em toque (onClick, fim de um salvar...);
//  * detalhes passam por uma peneira: so' numero, sim/nao e codigo curto (a-z0-9_.-);
//  * a unica excecao e' a mensagem de ERRO, mascarada aqui (e-mail, id, numeros) e no banco;
//  * funcao ausente no banco (404) -> desliga em silencio ate' recarregar a pagina;
//  * a pessoa pode desligar (Configuracoes): a recusa fica no banco e em plen_uso_off.
//
// Formato de cada evento enviado (as chaves sao as colunas de uso_eventos):
//   { ocorrido_em, sessao, evento, area, tela, fluxo, fluxo_inst, passo, plataforma,
//     versao, duracao_ms, n, detalhes, erro }
// Convencoes de nome:
//   tela.ver / tela.tempo {tela, duracao_ms}       janela.abrir {detalhes.nome}
//   fluxo.inicio / fluxo.passo / fluxo.saiu         fluxo.fim {detalhes.resultado}
//   aviso.bloqueio {fluxo, fluxo_inst, passo, detalhes.motivo}     aviso.toast
//   acao.<nome>  (nome com 1 ou 2 partes: 'whatsapp.abrir')        erro.<tipo> {erro}
//   sessao.login / sessao.cadastro / sessao.logout / sessao.conta_excluida   app.abrir
// SEM LOGIN o banco so' aceita o que a tela de entrada produz (catalogo fechado em
// registrar_uso, sql/central_uso.sql): telas entrada.* / painel.login, funis cadastro,
// entrada_convite, login, senha_recuperar, senha_redefinir, acoes entrada.*, erros. Funil ou
// tela nova que aconteca ANTES do login precisa entrar la' tambem, senao chega sem nome.
// Codigos (evento, tela, funil) nunca levam 4+ digitos seguidos; detalhes, nunca 3+ digitos.
// ---------------------------------------------------------------------------
import React from 'react';

const CODIGO = /^[a-z][a-z0-9_]*(\.[a-z0-9_]+){0,3}$/;
const CHAVE_DET = /^[a-z_]{1,30}$/;
const VALOR_DET = /^[a-z0-9_.-]{1,40}$/;
const INST = /^[a-z0-9]{4,16}$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const REDE = /Failed to fetch|NetworkError|Load failed|network request failed/i;
const PREFIXOS = { app: 1, tela: 1, janela: 1, fluxo: 1, acao: 1, aviso: 1, erro: 1, push: 1, sessao: 1 };
const AREAS = { professor: 1, aluno: 1, entrada: 1, painel: 1 };

const K_SESSAO = 'plen_uso_sessao';
const K_OFF = 'plen_uso_off';
const PARADO_MAX = 30 * 60 * 1000;   // 30 min sem nada (inclusive em segundo plano) = sessao nova
const FILA_MAX = 200;                // acima disso, descarta os mais velhos
const LOTE = 40;                     // eventos por envio
const JUNTAR = 20;                   // juntou isso -> envia na hora
const INTERVALO = 15000;             // senao, envia a cada 15 s
const ERROS_POR_SESSAO = 40;         // um erro em laco nao inunda o banco

const est = {
  iniciado: false, morto: false, desligado: false,
  supabase: null, url: '', anonKey: '', versao: null, plataforma: 'web',
  token: null, userId: null,
  sessao: null, ultimo: 0, ultimoGravado: 0,
  area: null, fila: [], relogio: null,
  tela: null, telaVista: false, telaInicio: 0, telaAcum: 0, timerTela: null, visivel: true,
  remontouAte: 0, errosSessao: 0, ultimoErro: '', ultimoErroEm: 0,
};

function agora() { return Date.now(); }
function lerLS(k) { try { return localStorage.getItem(k); } catch { return null; } }
function gravarLS(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch {} }
function lerSS(k) { try { return sessionStorage.getItem(k); } catch { return null; } }
function gravarSS(k, v) { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch {} }
function codigoOk(c, max = 60) { return typeof c === 'string' && c.length <= max && CODIGO.test(c); }

function novoUuid() {
  try { if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID(); } catch {}
  const b = new Uint8Array(16);
  try { crypto.getRandomValues(b); } catch { for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256); }
  b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, x => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
// Identificador de UMA passada por um funil (um cadastro de aluno, um convite...).
function novaInst() {
  return (agora().toString(36).slice(-4) + Math.random().toString(36).slice(2, 8)).replace(/[^a-z0-9]/g, '').padEnd(8, '0').slice(0, 12);
}

function detectarPlataforma() {
  try {
    const C = window.Capacitor;
    const p = C && typeof C.getPlatform === 'function' ? C.getPlatform() : null;
    if (p === 'ios' || p === 'android') return p;
    const standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
    return standalone ? 'pwa' : 'web';
  } catch { return 'web'; }
}

// Peneira dos detalhes: objeto plano, ate' 8 chaves, valores numero / sim-nao / codigo curto.
// Texto de gente (nome, frase, valor com virgula) nao passa no formato e e' descartado aqui.
function peneira(d) {
  if (!d || typeof d !== 'object' || Array.isArray(d)) return null;
  const out = {};
  let n = 0;
  for (const k of Object.keys(d)) {
    if (n >= 8) break;
    if (!CHAVE_DET.test(k)) continue;
    const v = d[k];
    if (typeof v === 'boolean') { /* ok */ }
    else if (typeof v === 'number') { if (!Number.isFinite(v)) continue; }
    else if (typeof v === 'string') { if (!VALOR_DET.test(v)) continue; }
    else continue;
    out[k] = v; n++;
  }
  return n ? out : null;
}

// Mensagem de erro sem dado pessoal: e-mail, token, id e numeros longos viram marcas.
export function mascararErro(m) {
  let s = '';
  try { s = String(m == null ? '' : (typeof m === 'object' && m.message ? m.message : m)); } catch { s = ''; }
  return s
    .replace(/%40/gi, '@')                                           // e-mail dentro de endereco
    .replace(/(Key \([^)]*\))=\([^)]*\)/g, '$1=(...)')                // valor citado pelo banco
    .replace(/(Failing row contains) \(.*\)/g, '$1 (...)')
    .replace(/eyJ[\w-]+\.[\w-]+\.[\w-]+/g, '[token]')
    .replace(/[^\s@'"<>(),;:]+@[^\s@'"<>(),;:]+\.[^\s@'"<>(),;:]+/g, '[email]')
    .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '[id]')
    .replace(/\d{3,}/g, '#')
    .slice(0, 200);
}

// v141: o "erro.promessa" (promessa recusada que ninguem tratou) chegava so' com a mensagem — as
// vezes generica ("The request is not allowed...") ou "[object Object]" — e nao dava para saber de
// onde vinha. Agora vai: o nome do erro (NotAllowedError, TypeError...), ONDE (as 2 primeiras funcoes
// da pilha, so' o nome — nunca o endereco do arquivo), a mensagem e o codigo (PGRST..., 23505...).
// O nome e o lugar vem PRIMEIRO: o texto e' cortado em 200 (120 sem login).
const PILHA_IGNORAR = /^(Promise|step|fulfilled|rejected|asyncGeneratorStep|_next|_throw|eval|next|throw|Generator|__awaiter|promiseReactionJob|anonymous)$/;
function origemDaPilha(stack) {
  const nomes = [];
  String(stack || '').split('\n').forEach(l => {
    if (nomes.length >= 2) return;
    const m = l.match(/^\s*at (?:async )?([\w$.]+) \(/)   // Chrome/Android: "    at nome (arquivo:1:2)"
      || l.match(/^\s*([\w$.]+)@/);                      // Safari/Firefox: "nome@arquivo:1:2"
    if (!m) return;
    const n = m[1].split('.').pop();
    if (!n || PILHA_IGNORAR.test(n) || nomes.indexOf(n) >= 0) return;
    nomes.push(n);
  });
  return nomes.join('<');
}
// No ar o pacote (dist/app.js) sai MINIFICADO da Netlify: os nomes de funcao viram 1-2 letras e o "em X<Y"
// ajuda pouco. Vai junto a POSICAO do 1o ponto da pilha que esta' no app (linha:coluna), com os digitos
// trocados por letras (0=a 1=b ... 9=j) porque a central troca 3+ digitos por "#". Para achar o lugar no
// codigo: destrocar as letras e procurar a posicao no dist/app.js.map da MESMA versao (a Netlify gera o
// mapa junto, --sourcemap). Ex.: "pos b:cdefg" = linha 1, coluna 23456.
function posicaoNoApp(stack) {
  const m = String(stack || '').match(/\/dist\/app\.js(?:\?[^:\s)]*)?:(\d+):(\d+)/);
  if (!m) return '';
  const letras = t => t.replace(/\d/g, d => 'abcdefghij'[Number(d)]);
  return letras(m[1]) + ':' + letras(m[2]);
}
export function descreverRejeicao(r) {
  try {
    if (r == null) return 'sem motivo';
    if (typeof r !== 'object') return String(r);
    let msg = r.message != null ? String(r.message) : '';
    if (!msg) { try { msg = JSON.stringify(r) || ''; } catch { msg = ''; } }
    if (!msg || msg === '{}') msg = Object.prototype.toString.call(r);
    const nome = r.name && r.name !== 'Error' ? String(r.name) : '';
    const cod = r.code != null && r.code !== '' ? String(r.code) : '';
    const onde = origemDaPilha(r.stack);
    const pos = posicaoNoApp(r.stack);
    const cabeca = (nome || 'Erro') + (onde ? ' em ' + onde : '') + (pos ? ' (pos ' + pos + ')' : '');
    return cabeca + ': ' + msg.slice(0, 140) + (cod ? ' [' + cod + ']' : '');
  } catch { return 'sem descricao'; }
}

function inteiro(v, min, max) {
  const n = Math.round(Number(v));
  if (!Number.isFinite(n) || n < min || n > max) return null;
  return n;
}

// ---- Sessao ----------------------------------------------------------------
// uuid em memoria + plen_uso_sessao {id, ultimo}. Troca depois de 30 min parado. A mesma
// sessao continua depois do login (e' isso que liga o funil de cadastro a conta criada) e
// atravessa a recarga da pagina (volta do Google, link de convite). Devolve true se nasceu agora.
function sessaoAtual() {
  const t = agora();
  let nova = false;
  if (!est.sessao || t - est.ultimo > PARADO_MAX) {
    let s = null;
    if (!est.sessao) { try { s = JSON.parse(lerLS(K_SESSAO) || 'null'); } catch { s = null; } }
    if (s && UUID.test(String(s.id || '')) && t - Number(s.ultimo || 0) <= PARADO_MAX) est.sessao = s.id;
    else { est.sessao = novoUuid(); nova = true; est.errosSessao = 0; }
  }
  est.ultimo = t;
  if (nova || t - est.ultimoGravado > 5000) {
    est.ultimoGravado = t;
    gravarLS(K_SESSAO, JSON.stringify({ id: est.sessao, ultimo: t }));
  }
  return nova;
}

// ---- Fila ------------------------------------------------------------------
function enfileirar(evento, campos) {
  if (!est.iniciado || est.morto || est.desligado) return;
  if (!codigoOk(evento) || !PREFIXOS[evento.split('.')[0]]) return;
  const c = campos || {};
  const item = {
    ocorrido_em: new Date().toISOString(),
    sessao: est.sessao,
    evento,
    area: est.area,
    tela: est.tela,
    plataforma: est.plataforma,
    versao: est.versao,
  };
  if ('tela' in c) item.tela = c.tela || null;
  if (item.tela && !codigoOk(item.tela, 40)) item.tela = null;
  if (c.fluxo && codigoOk(c.fluxo, 40)) item.fluxo = c.fluxo;
  if (c.fluxo_inst && INST.test(c.fluxo_inst)) item.fluxo_inst = c.fluxo_inst;
  if (c.passo != null) { const p = inteiro(c.passo, 0, 50); if (p != null) item.passo = p; }
  if (c.duracao_ms != null) { const d = inteiro(c.duracao_ms, 0, 86400000); if (d != null) item.duracao_ms = d; }
  if (c.n != null) { const n = inteiro(c.n, 0, 100000); if (n != null) item.n = n; }
  const det = peneira(c.detalhes);
  if (det) item.detalhes = det;
  if (c.erro != null && evento.indexOf('erro.') === 0) item.erro = mascararErro(c.erro);
  if (!est.area) item._semArea = 1;
  est.fila.push(item);
  if (est.fila.length > FILA_MAX) est.fila.splice(0, est.fila.length - FILA_MAX);
  if (est.fila.length >= JUNTAR) enviar(false);
}

// Sessao nova (30 min parado) -> app.abrir e a tela atual de novo. `evento`: o que vem a seguir.
function garantirSessao(evento) {
  if (!est.iniciado) return;
  const nova = sessaoAtual();
  if (nova && evento !== 'app.abrir') {
    enfileirar('app.abrir', { tela: est.tela });
    if (est.tela && String(evento || '').indexOf('tela.') !== 0) { est.telaVista = true; enfileirar('tela.ver', { tela: est.tela }); }
  }
}
// Porta de entrada de todo evento.
function registrar(evento, campos) {
  try {
    if (!est.iniciado || est.morto || est.desligado) return;
    garantirSessao(evento);
    enfileirar(evento, campos);
  } catch {}
}

// ---- Envio -----------------------------------------------------------------
function semMarcas(it) {
  const r = {};
  for (const k in it) if (k !== '_semArea') r[k] = it[k];
  return r;
}
function renovarToken() {
  try {
    return est.supabase.auth.getSession()
      .then(r => { est.token = (r && r.data && r.data.session && r.data.session.access_token) || null; })
      .catch(() => {});
  } catch { return Promise.resolve(); }
}
function mandar(lote, retentativa) {
  try {
    fetch(est.url + '/rest/v1/rpc/registrar_uso', {
      method: 'POST',
      keepalive: true,
      headers: {
        apikey: est.anonKey,
        Authorization: 'Bearer ' + (est.token || est.anonKey),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ p_eventos: lote }),
    }).then(r => {
      if (r.status === 401 && !retentativa) { renovarToken().then(() => mandar(lote, true)); return; }
      if (r.status === 404) { desativarAteRecarregar(); return; }
      // qualquer outra falha: o lote vai fora (sem laco de tentativas)
    }).catch(() => {});
  } catch {}
}
function enviar(final) {
  try {
    if (!est.iniciado || est.morto) return;
    if (est.desligado) { est.fila.length = 0; return; }
    const rodadas = final ? 4 : 1;
    for (let i = 0; i < rodadas && est.fila.length; i++) {
      mandar(est.fila.splice(0, LOTE).map(semMarcas), false);
    }
  } catch {}
}
function desativarAteRecarregar() {
  est.morto = true;
  est.fila.length = 0;
  try { clearInterval(est.relogio); } catch {}
}

// ---- Tela ------------------------------------------------------------------
// tela.ver sai 400 ms depois (a tela que pisca — o login antes do convite chegar — nao conta);
// tela.tempo leva so' o tempo VISIVEL (segundo plano nao conta).
function confirmarTela() {
  try {
    if (est.tela && !est.telaVista) { est.telaVista = true; registrar('tela.ver', { tela: est.tela }); }
  } catch {}
}
// Tela aberta e ninguem mexendo ha mais de 30 min (aba esquecida no computador): o tempo dela
// vai para a sessao em que ela estava (sem abrir sessao nova so' para isso) e conta no maximo
// ate' o ultimo evento daquela sessao (30 min no maximo) — senao uma aba esquecida por 8 h
// puxaria a media de tempo da tela para cima.
function parado() { return !!est.sessao && agora() - est.ultimo > PARADO_MAX; }
function tempoDaTela(dur) {
  try {
    if (parado()) { enfileirar('tela.tempo', { tela: est.tela, duracao_ms: Math.min(PARADO_MAX, est.telaAcum + Math.max(0, est.ultimo - est.telaInicio)) }); return; }
    registrar('tela.tempo', { tela: est.tela, duracao_ms: dur });
  } catch {}
}
function fecharTela() {
  try { clearTimeout(est.timerTela); } catch {}
  if (!est.tela || !est.telaVista) return;
  if (!est.visivel && !est.telaAcum) return;   // o tempo ja' foi contado ao ir para o segundo plano
  tempoDaTela(est.telaAcum + (est.visivel ? agora() - est.telaInicio : 0));
}
function aoEsconder() {
  try {
    if (est.visivel) {
      const estavaParado = parado();
      est.visivel = false;
      if (est.tela) {
        if (!est.telaVista) confirmarTela();
        else tempoDaTela(est.telaAcum + (agora() - est.telaInicio));
        try { clearTimeout(est.timerTela); } catch {}
        est.telaAcum = 0;
      }
      if (est.sessao) gravarLS(K_SESSAO, JSON.stringify({ id: est.sessao, ultimo: estavaParado ? est.ultimo : agora() }));
    }
    enviar(true);
  } catch {}
}
function aoMostrar() {
  try {
    if (est.visivel) return;
    est.visivel = true;
    est.telaInicio = agora();
    est.telaAcum = 0;
    if (!est.iniciado || est.morto || est.desligado) return;
    garantirSessao('');
  } catch {}
}

// Saiu da conta (ou trocou de conta no mesmo aparelho): o que esta' na fila sai com o token
// antigo e a SESSAO troca — senao o que a proxima pessoa fizer no mesmo aparelho ficaria na
// mesma sessao da anterior e o painel misturaria as duas. Entrar (sem conta -> conta) NAO troca:
// e' isso que liga o caminho do cadastro a conta criada.
function trocarSessao() {
  try {
    if (est.tela && est.telaVista && est.visivel && est.sessao) {
      enfileirar('tela.tempo', { tela: est.tela, duracao_ms: est.telaAcum + Math.max(0, agora() - est.telaInicio) });
    }
    est.tela = null; est.telaVista = false; est.telaAcum = 0; est.telaInicio = agora();
    try { clearTimeout(est.timerTela); } catch {}
    est.sessao = null; est.ultimo = 0; est.errosSessao = 0;
    gravarLS(K_SESSAO, null);
  } catch {}
}
function aoMudarLogin(session) {
  try {
    const uid = (session && session.user && session.user.id) || null;
    if (est.userId && uid !== est.userId) {   // saiu ou trocou de conta sem passar por sairDaConta
      enviar(true);                           // a fila vai com o token antigo (ainda em est.token)
      trocarSessao();
      est.userId = null;
    }
    est.token = (session && session.access_token) || null;
    if (uid && uid !== est.userId) { est.userId = uid; lerPreferencia(); }
  } catch {}
}
// A recusa mora no banco (uso_recusas); aqui so' a copia local para nao enviar nada.
function lerPreferencia() {
  try {
    est.supabase.rpc('minha_preferencia_uso').then(r => {
      if (!r || r.error) return;
      if (r.data === false) uso.desligar();
      else if (r.data === true) uso.ligar();
    }, () => {});
  } catch {}
}

// ---- API -------------------------------------------------------------------
export function iniciarUso({ supabase, url, anonKey, versao } = {}) {
  try {
    if (est.iniciado || typeof window === 'undefined' || typeof document === 'undefined') return;
    if (!url || !anonKey || typeof fetch !== 'function') return;
    est.supabase = supabase;
    est.url = String(url).replace(/\/+$/, '');
    est.anonKey = anonKey;
    est.versao = /^plen-v[0-9]{1,4}$/.test(String(versao || '')) ? versao : null;
    est.plataforma = detectarPlataforma();
    est.desligado = lerLS(K_OFF) === '1';
    est.visivel = document.visibilityState !== 'hidden';
    est.telaInicio = agora();
    est.iniciado = true;
    if (sessaoAtual()) enfileirar('app.abrir', {});
    if (supabase && supabase.auth) {
      try { supabase.auth.getSession().then(r => aoMudarLogin(r && r.data && r.data.session)).catch(() => {}); } catch {}
      // fora do callback: chamar o supabase de dentro dele pode travar (aviso da propria biblioteca)
      try { supabase.auth.onAuthStateChange((_ev, session) => { setTimeout(() => aoMudarLogin(session), 0); }); } catch {}
    }
    est.relogio = setInterval(() => enviar(false), INTERVALO);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') aoEsconder(); else aoMostrar();
    });
    window.addEventListener('pagehide', aoEsconder);
    window.addEventListener('error', (e) => {
      try {
        const msg = e && e.message;
        if (!msg || /ResizeObserver loop/i.test(msg)) return;   // falha de imagem/arquivo nao tem message
        uso.erro('erro.js', msg);
      } catch {}
    });
    window.addEventListener('unhandledrejection', (e) => {
      try {
        const r = e && e.reason;
        const msg = String((r && r.message) || r || '');
        // falha de rede: so' a mensagem (como antes); o resto leva nome, lugar e codigo (v141)
        uso.erro(REDE.test(msg) ? 'erro.rede' : 'erro.promessa', REDE.test(msg) ? msg : descreverRejeicao(r));
      } catch {}
    });
  } catch {}
}

export const uso = {
  // evento generico (nome completo: 'push.tocou', 'sessao.login'...). sessao.logout e
  // sessao.conta_excluida fecham a sessao: o que vier depois (a tela de entrada) e' sessao nova.
  evento(nome, campos) {
    try {
      registrar(nome, campos);
      if (nome === 'sessao.logout' || nome === 'sessao.conta_excluida') { trocarSessao(); est.userId = null; }
    } catch {}
  },

  // tela atual (para quem abre uma janela com abas e precisa voltar a' tela de antes ao fechar)
  telaAtual() { return est.tela; },

  tela(codigo) {
    try {
      if (!codigoOk(codigo, 40) || codigo === est.tela) return;
      fecharTela();
      est.tela = codigo;
      est.telaVista = false;
      est.telaInicio = agora();
      est.telaAcum = 0;
      est.timerTela = setTimeout(confirmarTela, 400);
    } catch {}
  },

  janela(nome, n) {
    try { registrar('janela.abrir', { detalhes: { nome: VALOR_DET.test(String(nome || '')) ? nome : 'outra' }, n }); } catch {}
  },

  acao(nome, detalhes) {
    try { if (codigoOk('acao.' + nome)) registrar('acao.' + nome, { detalhes }); } catch {}
  },

  // Validacao que barrou a pessoa num funil (ou fora de um: inst null).
  bloqueio(fluxo, inst, passo, motivo, detalhes) {
    try {
      registrar('aviso.bloqueio', {
        fluxo: codigoOk(fluxo, 40) ? fluxo : null,
        fluxo_inst: inst || null,
        passo,
        detalhes: Object.assign({}, detalhes || {}, { motivo: VALOR_DET.test(String(motivo || '')) ? motivo : 'outro' }),
      });
    } catch {}
  },

  erro(tipo, mensagem) {
    try {
      let t = String(tipo || 'erro.outro');
      if (t.indexOf('erro.') !== 0) t = 'erro.' + t;
      if (!codigoOk(t)) t = 'erro.outro';
      const msg = mascararErro(mensagem);
      const marca = t + '|' + msg;
      if (marca === est.ultimoErro && agora() - est.ultimoErroEm < 5000) return;   // o mesmo, repetido
      est.ultimoErro = marca; est.ultimoErroEm = agora();
      if (++est.errosSessao > ERROS_POR_SESSAO) return;
      registrar(t, { erro: msg });
    } catch {}
  },

  area(a) {
    try {
      if (!AREAS[a] || a === est.area) return;
      est.area = a;
      for (const it of est.fila) if (it._semArea) { it.area = a; delete it._semArea; }
    } catch {}
  },

  // O App remontou sozinho (renovacao do token): as saidas de funil dos proximos segundos
  // vao marcadas com remontou=true — nao foi a pessoa que desistiu.
  remontagem() {
    try { est.remontouAte = agora() + 5000; registrar('app.remontou'); } catch {}
  },

  // Antes de sair da conta / excluir: manda o que esta' na fila com o token ainda valido.
  enviarAgora() { enviar(true); },

  desligar() {
    try { est.desligado = true; est.fila.length = 0; gravarLS(K_OFF, '1'); } catch {}
  },
  ligar() {
    try { est.desligado = false; gravarLS(K_OFF, null); } catch {}
  },
  ligado() { return !est.desligado; },

  fluxo(nome) { return fluxoSolto(nome); },
};

// ---- Funil -----------------------------------------------------------------
// useFluxoUso(nome, passo, ativo, { persistir })
//  * ativou -> fluxo.inicio (gera fluxo_inst); passo mudou -> fluxo.passo;
//  * desativou ou desmontou sem fim() -> fluxo.saiu com o ultimo passo;
//  * fim(resultado, detalhes) -> fluxo.fim {resultado}; barrar(motivo) -> aviso.bloqueio no passo atual;
//  * persistir: a passada sobrevive a recarga da pagina (sessionStorage) — cadastro e convite,
//    que atravessam o login do Google e o reload depois de assumir a ficha. Nesses, desmontar
//    nao conta como saida (quem diz que acabou e' o fim() ou o fim da sessao, no servidor).
export function useFluxoUso(nome, passo, ativo = true, opcoes) {
  const ref = React.useRef(null);
  const persistir = !!(opcoes && opcoes.persistir);
  const chave = 'plen_uso_fluxo_' + nome;
  const p = Number.isFinite(passo) ? passo : null;

  const salvar = () => { if (persistir && ref.current) gravarSS(chave, JSON.stringify(Object.assign({ sessao: est.sessao }, ref.current))); };
  const encerrar = (motivo) => {
    try {
      const r = ref.current;
      ref.current = null;
      if (persistir) gravarSS(chave, null);
      if (!r) return;
      const det = agora() < est.remontouAte ? { remontou: true } : {};
      if (motivo && VALOR_DET.test(motivo)) det.motivo = motivo;
      registrar('fluxo.saiu', { fluxo: nome, fluxo_inst: r.inst, passo: r.passo, detalhes: det });
    } catch {}
  };

  React.useEffect(() => {
    try {
      if (!ativo) { encerrar(); return; }
      if (!ref.current) {
        let rec = null;
        if (persistir) { try { rec = JSON.parse(lerSS(chave) || 'null'); } catch { rec = null; } }
        if (rec && INST.test(String(rec.inst || '')) && rec.sessao === est.sessao) {
          ref.current = { inst: rec.inst, passo: rec.passo };
          if (p != null && p !== rec.passo) {
            ref.current.passo = p;
            registrar('fluxo.passo', { fluxo: nome, fluxo_inst: rec.inst, passo: p });
          }
        } else {
          ref.current = { inst: novaInst(), passo: p };
          registrar('fluxo.inicio', { fluxo: nome, fluxo_inst: ref.current.inst, passo: p });
        }
        salvar();
      } else if (ref.current.passo !== p) {
        ref.current.passo = p;
        registrar('fluxo.passo', { fluxo: nome, fluxo_inst: ref.current.inst, passo: p });
        salvar();
      }
    } catch {}
  }, [ativo, p]);

  React.useEffect(() => () => { if (!persistir) encerrar(); }, []);

  const fim = React.useCallback((resultado, detalhes) => {
    try {
      let r = ref.current;
      if (!r && persistir) { try { r = JSON.parse(lerSS(chave) || 'null'); } catch { r = null; } }
      if (!r) return;
      ref.current = null;
      if (persistir) gravarSS(chave, null);
      const det = Object.assign({}, detalhes || {}, { resultado: VALOR_DET.test(String(resultado || '')) ? resultado : 'concluiu' });
      registrar('fluxo.fim', { fluxo: nome, fluxo_inst: r.inst, passo: r.passo, detalhes: det });
    } catch {}
  }, []);

  // Sem passada aberta (funil desligado, ex.: a mesma janela em modo "editar") nao conta como
  // bloqueio do funil — senao o painel somaria travas de quem nem estava no assistente.
  const barrar = React.useCallback((motivo, detalhes) => {
    try {
      const r = ref.current;
      if (r) uso.bloqueio(nome, r.inst, r.passo, motivo, detalhes);
    } catch {}
  }, []);

  // Saiu sem concluir por um motivo conhecido (ex.: 'reativou', 'ignorou'). Sem motivo, a
  // saida comum ja' e' registrada sozinha ao desmontar/desativar.
  const sair = React.useCallback((motivo) => { encerrar(motivo); }, []);

  return { fim, barrar, sair };
}

// ---- Funil fora de componente (entrada) --------------------------------------
// uso.fluxo('cadastro').passo(2) — para os funis que atravessam varias telas e recargas
// (AuthPage -> TipoUsuario -> app; volta do Google; reload depois de assumir a ficha).
// Fica no sessionStorage, amarrado a sessao de uso: sessao nova = passada velha esquecida
// (o servidor ja' conta como saida). O passo so' sobe.
// A passada fica em memoria E no sessionStorage (a copia so' serve para atravessar a recarga).
// Com o armazenamento bloqueado (Safari "bloquear cookies", navegador embutido) a memoria segura:
// sem isso, cada passo abria uma passada nova.
const fluxoMem = {};
function lerFluxoSS(nome) {
  try {
    let r = null;
    const bruto = lerSS('plen_uso_fluxo_' + nome);
    if (bruto) { try { r = JSON.parse(bruto); } catch { r = null; } }
    else if (Object.prototype.hasOwnProperty.call(fluxoMem, nome)) r = fluxoMem[nome];
    if (r && INST.test(String(r.inst || '')) && r.sessao === est.sessao) return r;
  } catch {}
  return null;
}
function gravarFluxo(chave, nome, r) {
  try { if (r) fluxoMem[nome] = r; else delete fluxoMem[nome]; } catch {}
  gravarSS(chave, r ? JSON.stringify(r) : null);
}
function fluxoSolto(nome) {
  const chave = 'plen_uso_fluxo_' + nome;
  return {
    // soSeExiste: avanca so' quem ja' esta' no funil (nao abre passada nova no meio)
    passo(n, detalhes, soSeExiste) {
      try {
        if (!est.iniciado || !Number.isFinite(n)) return;
        garantirSessao('');
        let r = lerFluxoSS(nome);
        if (!r) {
          if (soSeExiste) return;
          r = { inst: novaInst(), passo: n, sessao: est.sessao };
          registrar('fluxo.inicio', { fluxo: nome, fluxo_inst: r.inst, passo: n, detalhes });
        } else if (n > (r.passo || 0)) {
          r.passo = n;
          registrar('fluxo.passo', { fluxo: nome, fluxo_inst: r.inst, passo: n, detalhes });
        } else return;
        gravarFluxo(chave, nome, r);
      } catch {}
    },
    fim(resultado, detalhes) {
      try {
        garantirSessao('');
        const r = lerFluxoSS(nome);
        gravarFluxo(chave, nome, null);
        if (!r) return;
        const det = Object.assign({}, detalhes || {}, { resultado: VALOR_DET.test(String(resultado || '')) ? resultado : 'concluiu' });
        registrar('fluxo.fim', { fluxo: nome, fluxo_inst: r.inst, passo: r.passo, detalhes: det });
      } catch {}
    },
    sair(motivo) {
      try {
        garantirSessao('');
        const r = lerFluxoSS(nome);
        gravarFluxo(chave, nome, null);
        if (!r) return;
        registrar('fluxo.saiu', { fluxo: nome, fluxo_inst: r.inst, passo: r.passo, detalhes: motivo && VALOR_DET.test(motivo) ? { motivo } : null });
      } catch {}
    },
    // so' conta se a pessoa estiver numa passada deste funil (o link de pedido do aluno, um
    // codigo velho guardado... nao abrem passada e nao podem somar bloqueio no funil)
    barrar(motivo, detalhes) {
      try {
        garantirSessao('');
        const r = lerFluxoSS(nome);
        if (r) uso.bloqueio(nome, r.inst, r.passo, motivo, detalhes);
      } catch {}
    },
    passoAtual() {
      try { garantirSessao(''); const r = lerFluxoSS(nome); return r ? r.passo || 0 : 0; } catch { return 0; }
    },
  };
}

// ---- Catalogos (o painel usa para nomes legiveis e para "nunca abertas") -----
export const TELAS_CONHECIDAS = {
  // entrada (sem login)
  'entrada.login': 'Entrar (login)',
  'entrada.register': 'Criar conta',
  'entrada.tipo': 'Escolher papel (professor ou aluno)',
  'entrada.tipo_convite': 'Boas-vindas do aluno convidado',
  'entrada.tipo_pedido_prof': 'Professor convidado pelo aluno',
  'entrada.convite_ios': 'Link de convite no iPhone sem o app: página "Baixar o Plen" (desde a v147)',
  'entrada.tipo_indicacao': 'Professor convidado por outro professor — a conta vira de professor sem a pergunta (e-mail: "Preparando sua conta de professor…"; Google: "Começar como professor"; desde a v147)',
  'entrada.redefinir_senha': 'Criar nova senha',
  // professor
  'prof.onboarding': 'Boas-vindas do professor',
  'prof.dashboard': 'Início (professor)',
  'prof.planos': 'Meus planos',
  'prof.alunos': 'Alunos',
  'prof.turmas': 'Turmas',
  'prof.contratos': 'Acordos',
  'prof.agenda': 'Calendário',
  'prof.aulas': 'Aulas',
  'prof.financeiro.pagamentos': 'Financeiro — pagamentos',
  'prof.financeiro.inadimplentes': 'Financeiro — em atraso',
  'prof.financeiro.relatorio': 'Financeiro — relatório',
  'prof.relatorios': 'Relatórios (em breve)',
  'prof.notificacoes': 'Avisos (até a v133)',
  'prof.pendencias': 'Pendências (professor; desde a v134 — com o histórico de avisos embaixo)',
  'prof.config.conta': 'Configurações — meu perfil',
  'prof.config.alertas': 'Configurações — alertas',
  'prof.config.plataforma': 'Configurações — plataforma',
  'prof.config.piloto': 'Configurações — painel do piloto',
  'prof.ficha.contrato': 'Ficha do aluno — acordo',
  'prof.ficha.agenda': 'Ficha do aluno — agenda',
  'prof.ficha.aulas': 'Ficha do aluno — aulas',
  'prof.ficha.pagamentos': 'Ficha do aluno — pagamentos',
  'prof.ficha.dados': 'Ficha do aluno — dados',
  'prof.erro_perfil': 'Erro ao carregar o perfil do professor',
  // aluno
  'aluno.inicio': 'Início (aluno)',
  'aluno.aulas': 'Minhas aulas',
  'aluno.plano': 'Meu plano',
  'aluno.financeiro': 'Pagamentos (aluno)',
  'aluno.contrato': 'Acordo (aluno)',
  'aluno.notificacoes': 'Avisos (aluno, até a v133)',
  'aluno.pendencias': 'Pendências (aluno; desde a v134 — com o histórico de avisos embaixo)',
  'aluno.sem_professor': 'Aluno sem professor',
  'aluno.convite': 'Convite recebido',
  'aluno.acordo': 'Aceitar o acordo (portão)',
  'aluno.indicacao': 'Aluno logado abriu o convite de um professor para professores (desde a v147)',
  // painel
  'painel.login': 'Painel — login',
  'painel.inicio': 'Painel — início',
  'painel.pessoas': 'Painel — pessoas',
  'painel.detalhes': 'Painel — detalhes',
  // ate' a v138 (mantidos por causa do historico)
  'painel.uso': 'Painel — uso do app',
  'painel.piloto': 'Painel — piloto',
};

export const FLUXOS = {
  cadastro: { rotulo: 'Criar conta', passos: { 1: 'Abriu o cadastro', 2: 'Enviou os dados', 3: 'Conta criada', 4: 'Escolheu o papel', 5: 'Chegou no app' } },
  entrada_convite: { rotulo: 'Aluno entrando pelo convite', passos: { 1: 'Abriu o link', 2: 'Viu as boas-vindas', 3: 'Criou conta ou entrou', 4: 'Assumiu a ficha', 5: 'Chegou no início' } },
  onboarding_prof: { rotulo: 'Boas-vindas do professor', passos: { 1: 'Modalidades', 2: 'Avisos no celular', 3: 'Primeiro aluno' } },
  novo_aluno: { rotulo: 'Cadastrar aluno', passos: { 1: 'Nome', 2: 'Quanto cobra', 3: 'Quadra/sala', 4: 'Dias e horário', 5: 'Já começou?', 6: 'Já pagou?', 7: 'Regras', 8: 'Reajuste', 9: 'Resumo' } },
  renovar_pacote: { rotulo: 'Renovar pacote', passos: { 2: 'Quanto cobra', 3: 'Quadra/sala', 4: 'Dias e horário', 5: 'Já começou?', 6: 'Já pagou?', 9: 'Resumo' } },
  convite_enviar: { rotulo: 'Mandar convite ao aluno', passos: { 1: 'Pediu o convite', 2: 'Janela do convite aberta' } },
  nova_turma: { rotulo: 'Criar turma', passos: { 1: 'Abriu', 2: 'Deu o nome', 3: 'Escolheu os dias', 4: 'Horário completo' } },
  pagamento_registrar: { rotulo: 'Registrar pagamento', passos: { 1: 'Escolher o aluno', 2: 'Valor', 3: 'Pronto para salvar' } },
  pagamento_confirmar: { rotulo: 'Confirmar recebimento', passos: { 1: 'Abriu a confirmação' } },
  aluno_add_prof: { rotulo: 'Aluno adicionando professor (versão antiga, 3 perguntas)', passos: { 1: 'Quem é', 2: 'Dias e horário', 3: 'Pagamento', 4: 'Convite pronto' } },
  // v143: as mesmas perguntas do cadastro do professor, com os MESMOS numeros de passo (sem a sala, 3).
  // Nome novo porque o 2 mudou de sentido (era "Dias"); com o antigo o painel misturaria as versoes.
  aluno_add_prof2: { rotulo: 'Aluno adicionando professor', passos: { 1: 'Quem é', 2: 'Quanto paga', 4: 'Dias e horário', 5: 'Já começou?', 6: 'Já pagou?', 9: 'Confira', 10: 'Convite pronto' } },
  push_ativar: { rotulo: 'Ativar avisos no celular', passos: { 1: 'Pediu a permissão' } },
};

// Nomes de janela (janela.abrir detalhes.nome)
export const JANELAS_CONHECIDAS = {
  ficha_aluno: 'Ficha do aluno',
  aluno_encerrar: 'Encerrar vínculo',
  convite: 'Convite do aluno',
  convite_prof: 'Convidar outro professor (desde a v147)',
  agenda_horario_add: 'Adicionar horário',
  pagamento_registrar: 'Registrar pagamento',
  pagamento_confirmar: 'Confirmar recebimento',
  recibo: 'Recibo',
  turma_nova: 'Nova turma',
  turma_editar: 'Editar turma',
  turma_membros: 'Alunos da turma',
  turma_presenca: 'Presença da turma',
  novo_aluno: 'Cadastrar aluno',
  pacote_renovar: 'Renovar pacote',
  aluno_historico: 'Histórico do aluno',
  aulas_aluno: 'Aulas do aluno',
  acordo_revisao: 'Revisar acordo',
  acordo_wizard: 'Assistente de acordo',
  aula_avulsa: 'Registrar aula avulsa',
  reajuste_aluno: 'Reajuste do aluno',
  reajuste_financeiro: 'Reajuste (financeiro)',
  agenda_conflitos: 'Conflitos da agenda',
  aula_reagendar: 'Reagendar aula',
  atalho: 'Atalho +',
  sino: 'Sininho',
  'aluno.aula_opcoes': 'Aluno — opções da aula',
  'aluno.aula_cancelar': 'Aluno — cancelar aula',
  'aluno.aula_avisar': 'Aluno — avisar falta',
  'aluno.aula_reagendar': 'Aluno — reagendar aula',
  'aluno.perfil': 'Aluno — meu perfil',
  'aluno.add_prof': 'Aluno — adicionar professor',
  'aluno.convidar_prof': 'Aluno — convidar professor (janela do link solto; só até a v139 — desde a v140 é aluno.add_prof)',
  acordo_ver: 'Ver acordo',
  acordo_enviar: 'Enviar acordo',
  agenda_aula_acao: 'Agenda — o que fazer com a aula',
  agenda_aula_passada: 'Agenda — aula passada sem confirmar',
  agenda_horario_fixo: 'Agenda — mudar horário fixo',
  aula_reposicao: 'Vai ter reposição?',
  plano_novo: 'Novo plano (Meus planos)',
  pagamento_cancelar: 'Cancelar lançamento (escolher o motivo)',
  aviso_aluno_registrar: 'Professor — registrar que o aluno avisou (WhatsApp/ligação)',
  conflito_horario: 'Horário ocupado (remarcar ou confirmar aula)',
  aula_desmarcar_confirmar: 'Professor — confirmar "Eu desmarquei" (aula que o aluno disse que não consegue; desde a v136)',
  aula_opcoes_prof: 'Professor — Opções da aula (perguntar se vem / aluno avisou / não vou poder dar; desde a v140)',
  aula_nao_vou_dar: 'Professor — "Não vou poder dar esta aula" (motivo e prévia; desde a v140)',
  'aluno.aula_presenca': 'Aluno — "Tudo certo para a aula?" (Vou / Não vou conseguir; desde a v140)',
  'aluno.aula_nao_veio': 'Aluno — "O professor não chegou?" (desde a v140)',
  outra: 'Outra janela',
};

// Acoes (evento 'acao.' + codigo). O painel pode receber o codigo com ou sem o 'acao.'.
export const ACOES_CONHECIDAS = {
  // gerais (os dois lados; a area diz quem)
  'whatsapp.abrir': 'Abriu o WhatsApp (detalhe: motivo)',
  'agenda_celular.buscar': 'Buscou na agenda do celular (detalhe: origem novo_aluno / aluno_add_prof / turma, via nativo_sem_permissao / nativo / web, n = quantos escolheu)',
  'novo_aluno.entrada': 'Novo aluno: escolheu como pôr o nome (agenda ou digitar)',
  'suporte.whatsapp': 'Tocou em "Falar com o Plen" (WhatsApp)',
  'uso.preferencia': 'Ligou "Ajudar a melhorar o Plen"',
  'push.faixa_dispensar': 'Fechou a faixa de avisos',
  'push.tocou': 'Tocou num aviso do celular; detalhe: com_destino, acao tap / nao_vou / outra (desde a v147)',
  'push.passo_visto': 'App da loja: viu o cartão de avisos no Início (desde a v147; detalhe: quem, estado pedir / negado)',
  'push.passo_agora_nao': 'App da loja: tocou em "Agora não" no cartão de avisos (some por 1 dia)',
  'push.ajustes_abrir': 'Avisos desligados: tocou em "Abrir Ajustes"',
  'push.ajustes_entendi': 'Avisos desligados: tocou em "Entendi" (o cartão não volta)',
  'push.ligou_nos_ajustes': 'Ligou os avisos nos Ajustes do iPhone e voltou ao Plen',
  'push.icone': 'Número no ícone: o app conferiu este aparelho, 1 vez por sessão (desde a v148; detalhe: estado mostra / nao_mostra / sem_banco, via nativo / navegador / nenhum)',
  'app.erro_recarregar': 'Tocou em "Tentar novamente" na tela de erro',
  // entrada
  'entrada.google': 'Tocou em "Continuar com Google"',
  'entrada.esqueci_senha': 'Tocou em "Esqueci minha senha"',
  'entrada.recuperacao_enviada': 'E-mail de nova senha enviado',
  'entrada.senha_redefinida': 'Criou a senha nova',
  'entrada.ir_cadastro': 'Trocou para "Criar conta"',
  'entrada.ir_login': 'Trocou para "Entrar"',
  'entrada.tipo_sair': 'Saiu na escolha de papel',
  'entrada.link_solicitacao': 'Abriu o link de um pedido do aluno',
  'entrada.link_pedido': 'Link do pedido: achou / já resolvido',
  'entrada.link_pedido_prof': 'Professor abriu o link de convite do aluno',
  'entrada.convite_ios_baixar': 'Página do link no iPhone: tocou em "Baixar o Plen" (desde a v147; detalhe: copiou = o convite foi copiado)',
  'entrada.convite_ios_navegador': 'Página do link no iPhone: "Continuar no navegador"',
  'entrada.colar_convite': 'App da loja, tela de entrada: "Colar convite" (desde a v147; detalhe: resultado ok / sem_convite / sem_permissao / sem_resposta / invalido / sem_rede / codigo_invalido / bloqueado, via area / campo)',
  'entrada.link_indicacao': 'Abriu o link de convite de um professor para outros professores (desde a v147)',
  // professor — navegacao e inicio
  'atalho.novo_aluno': 'Atalho + → novo aluno',
  'atalho.nova_turma': 'Atalho + → nova turma',
  'sino.abrir_aviso': 'Abriu um aviso pelo sininho',
  'sino.renovar': 'Sininho → renovar plano',
  'sino.ver_acordo': 'Sininho → ver acordo',
  'sino.marcar_lidas': 'Sininho → marcar como lidas',
  'sino.ver_todas': 'Sininho → ver todas',
  'avisos.filtro': 'Filtrou a tela de avisos',
  'avisos.abrir': 'Abriu um aviso na tela de avisos',
  'avisos.ver_enviados': 'Viu o que foi enviado aos alunos',
  'pendencias.resolver': 'Pendências: tocou para resolver (detalhe: tipo da pendência; via inline = resolveu ali mesmo, navegar = foi para a tela onde se resolve)',
  'pendencias.historico': 'Pendências: abriu ou fechou o histórico de avisos',
  'inicio.numero': 'Tocou num número do topo do início',
  'inicio.primeiro_aluno': 'Início → cadastrar o primeiro aluno',
  'inicio.pedido_completar': 'Início → "<aluno> mandou o combinado": abriu o pedido do aluno para completar (desde a v147; detalhe: n = quantos pedidos)',
  'inicio.ver_agenda': 'Início → ver agenda',
  'inicio.ir_financeiro': 'Início → financeiro',
  'inicio.faturamento': 'Trocou bruto/líquido no início',
  'inicio.vencendo': 'Início → acordos vencendo',
  'feriado.resolver': 'Resolveu o feriado (dar aula ou pular)',
  'proposta_aula.responder': 'Respondeu aula lançada pelo aluno',
  'pedido.responder': 'Respondeu pedido do aluno',
  'ajuste.abrir_ficha': 'Abriu a ficha para corrigir o acordo',
  'reposicao.marcar': 'Marcou uma reposição',
  'onboarding.veio_de_aluno': 'Professor chegou pelo pedido de um aluno',
  'onboarding.modalidade_propria': 'Professor usou uma modalidade que não está na lista (digitou a dele)',
  'convite.pedido_aceito': 'Aceitou o pedido de um aluno',
  // professor — aulas
  'aula.marcar': 'Marcou aula (feita/falta/cancelada; status agendada = desfez). Desde a v131 conta só o que o banco aceitou; origem terminada em _veio = o aluno avisou fora do prazo, mas veio',
  'aula.avulsa': 'Registrou aula avulsa',
  'aula.reagendar': 'Reagendou uma aula (desde a v131 conta só o que o banco aceitou; detalhe: modo, forcado). Desde a v131 inclui as origens ficha e pedido — no aceite de pedido soma com pedido.responder (detalhe pedido=true). Desde a v136, aguarda_aluno=true: o aluno tem conta e pode dizer se não consegue',
  'remarcacao_recusada.abrir': 'Professor tocou em Remarcar/Desmarcar ("Eu desmarquei", depois do horário) numa aula que o aluno disse que não consegue no novo horário, no Início (desde a v136; detalhe: acao, origem). Pelas Pendências conta como pendencias.resolver. O "Eu desmarquei" confirmado entra em aula.marcar com origem remarcacao_recusada',
  'aula.cancelar_prof': 'Cancelou aula com motivo',
  'aula.remarcar_conflito': 'Horário ocupado: marcou mesmo assim ou escolheu outro (detalhe: forcou)',
  'aula.corrigir': 'Corrigiu o que aconteceu numa aula (ficha do aluno)',
  'aviso_aluno.registrar': 'Registrou que o aluno avisou que não vem (o banco decide o prazo)',
  'aviso_aluno.decidir': 'Aviso fora do prazo: Conta a aula ou Devolver',
  'opcoes_aula.abrir': 'Professor abriu as Opções de uma aula de hoje/amanhã (desde a v140; detalhe: origem inicio_hoje / inicio_amanha / agenda / agenda_nao_vou)',
  'presenca.pedir': 'Professor tocou em "Perguntar se o aluno vem" (desde a v140; detalhe: resultado ok / ja_feito / código da recusa / sem_funcao, origem, no_prazo). A opção "Não vou poder dar esta aula" conta em aula.marcar com origem opcoes',
  'presenca.whats': 'Professor abriu o WhatsApp com a pergunta "tudo certo para a aula?" pronta (desde a v140; detalhe: origem, motivo sem_app / perto / noite / sem_resposta / sem_funcao)',
  'inicio.aula_push': 'Início aberto pelo toque num aviso de aula (desde a v140; detalhe: achou, nao_veio)',
  'prof.aviso_aula_abrir': 'Professor abriu o app tocando num aviso de aula no celular (desde a v140)',
  'aulas.modo': 'Trocou dia/semana/mês nas aulas',
  'aulas.periodo': 'Andou o período nas aulas',
  'aulas.hoje': 'Aulas → hoje',
  'aulas.filtro_aluno': 'Filtrou aulas por aluno',
  'aulas.filtro_status': 'Filtrou aulas por situação',
  'aulas.dia_semana': 'Escolheu um dia da semana nas aulas',
  'agenda.gerar_aulas': 'Gerou aulas na agenda',
  'agenda.horario_add': 'Adicionou horário fixo',
  'agenda.horario_fixo': 'Mudou horário fixo',
  'agenda.filtro_aluno': 'Filtrou o calendário por aluno',
  'agenda.mes': 'Trocou o mês do calendário',
  // professor — alunos e convite
  'alunos.novo_botao': 'Botão "Novo aluno"',
  'alunos.novo_vazio': 'Cadastrar o primeiro aluno (lista vazia)',
  'alunos.novo_proposta': 'Cadastro aberto pelo pedido do aluno',
  'alunos.pedido_completar': 'Alunos: abriu um pedido de aluno para completar (desde a v147; detalhe: origem inicio / colar = colou o link no Início / lista)',
  'alunos.filtro': 'Filtrou a lista de alunos',
  'alunos.link_geral': 'Pediu o link de convite geral',
  'alunos.ir_turmas': 'Alunos → turmas',
  'alunos.chip': 'Tocou no chip de ação do aluno',
  'alunos.menu': 'Abriu o menu "···" do aluno',
  'alunos.menu_opcao': 'Escolheu uma opção do menu do aluno',
  'alunos.desvincular': 'Encerrou o vínculo com um aluno',
  'alunos.reativar': 'Reativou um aluno',
  'novo_aluno.horario_por_dia': 'Cadastro: horários diferentes por dia',
  'novo_aluno.mandar_acordo': 'Fim do cadastro → mandar o acordo',
  'novo_aluno.mudar_do_resumo': 'Novo aluno — tocou numa linha do resumo para mudar (desde a v143; detalhe: passo)',
  'novo_aluno.prazo_desmarcar': 'Novo aluno: "Combinaram prazo para desmarcar?" (desde a v147; detalhe: h = 0 livre, ou as horas)',
  'novo_aluno.abriu_pedido_parecido': 'Novo aluno em branco: o nome é de quem já mandou o combinado → abriu o pedido (desde a v147; detalhe: por nome / telefone)',
  'novo_aluno.pedido_juntar': 'Pedido do aluno: "É <aluno> — juntar as fichas" (desde a v147; detalhe: tinha_acordo)',
  'novo_aluno.pedido_juntar_desfez': 'Pedido do aluno: desfez o "juntar com a ficha que já tinha" (desde a v147)',
  'novo_aluno.pedido_caminho_antigo': 'Pedido do aluno caiu no cadastro antigo (desde a v147; detalhe: motivo sem_funcao = SQL v144_pedido não rodou / ficha_sem_conta)',
  'ficha.aba': 'Trocou de aba na ficha do aluno',
  'historico.aba': 'Trocou de aba no histórico do aluno',
  'convite.copiar': 'Copiou o link do convite',
  'convite.colar': 'App da loja, logado: "Colar convite" (desde a v147; detalhe: origem sem_professor / inicio_aluno / inicio_prof, resultado ok / sem_convite / sem_permissao / sem_resposta / invalido / sem_rede / tipo_errado / codigo_invalido / bloqueado / pedido_aberto = professor colou o pedido que já tinha aberto e o app abriu o pedido, via area / campo)',
  // v144: convite de professor para professor (indicacao)
  'convite_prof.gerar': 'Professor abriu "Convidar outro professor" e o link ficou pronto (detalhe: origem inicio / config; novo = link criado agora, senão o mesmo de antes)',
  'convite_prof.whats': 'Professor mandou o convite para outros professores pelo WhatsApp (detalhe: origem)',
  'convite_prof.copiar': 'Professor copiou o convite para outros professores (detalhe: origem; o_que mensagem / link)',
  'indicacao.entrou': 'Professor novo entrou pelo convite de outro professor (o banco anotou quem indicou e avisou quem indicou)',
  'indicacao.ja_professor': 'Professor que já tinha conta abriu o convite de outro professor (nada muda)',
  'indicacao.proprio_link': 'Professor abriu o próprio link de convite para professores',
  'indicacao.ja_feito': 'Professor abriu de novo o convite de outro professor que já estava anotado (desde a v147)',
  'indicacao.aluno_sair': 'Aluno logado abriu o convite de professor e saiu para criar a conta de professor',
  'indicacao.aluno_continuar': 'Aluno logado abriu o convite de professor e continuou como aluno',
  'convite.turma': 'Convidou alguém da turma',
  'reajuste.propor': 'Propôs reajuste',
  // professor — financeiro
  'financeiro.registrar_botao': 'Botão "Registrar pagamento"',
  'financeiro.filtro': 'Filtrou pagamentos',
  'financeiro.filtro_aluno': 'Filtrou pagamentos por aluno',
  'financeiro.limpar_filtro': 'Limpou o filtro do financeiro',
  'financeiro.relatorio_mes': 'Trocou o mês do relatório',
  'financeiro.exportar_pdf': 'Exportou relatório em PDF',
  'financeiro.ver_recibo': 'Abriu um recibo',
  'financeiro.imprimir_recibo': 'Imprimiu um recibo',
  'pagamento.confirmar': 'Confirmou recebimento (ou corrigiu data/forma)',
  'pagamento.reabrir': 'Voltou pagamento para em aberto',
  'pagamento.cancelar': 'Cancelou uma cobrança (com motivo; desde a v130 conta só o que o banco aceitou)',
  'pagamento.excluir': 'Cancelou lançamento pela lixeira (até a v129: excluía)',
  'ficha.pagamento_confirmar': 'Ficha do aluno: confirmou ou corrigiu um pagamento',
  'ficha.pagamento_cancelar': 'Ficha do aluno: cancelou um lançamento (com motivo)',
  // professor — acordos, turmas, planos, configuracoes
  'acordos.filtro': 'Filtrou a tela de acordos',
  'acordos.historico': 'Viu o histórico de acordos',
  'acordo.enviar': 'Mandou o acordo pelo app',
  'acordo.marcar_aceito': 'Marcou acordo como aceito',
  'ficha.chuva': 'Ficha do aluno: mudou a regra da chuva do acordo e tocou em salvar (desde a v148; detalhe: valor sim/nao, automatico = o que a modalidade daria)',
  'turma.expandir': 'Abriu uma turma',
  'turma.editar_salvar': 'Salvou a edição da turma',
  'turma.membros_add': 'Adicionou pessoas à turma',
  'turma.presenca': 'Fechou a presença da turma',
  'turma.cobrar_lote': 'Cobrou os pendentes da turma',
  'turma.preco': 'Mudou o valor de alguém na turma',
  'turma.remover_membro': 'Tirou alguém da turma',
  'turma.encerrar': 'Encerrou a turma',
  'plano.criar': 'Criou um plano',
  'plano.aproveitamento': 'Aluno abriu o aproveitamento do pacote',
  'plano.datas': 'Aluno abriu as datas das aulas do pacote (bolinhas)',
  'aulas.ir_historico': 'Aluno foi para o histórico de aulas',
  'perfil.salvar': 'Salvou o perfil (professor)',
  'alertas.salvar': 'Salvou os alertas',
  'lembrete_aula.preferencia': 'Ligou/desligou "Lembrar meus alunos antes da aula"',
  'lembrete_prof.preferencia': 'Mudou "Lembrar das minhas aulas" (aviso ao professor antes de cada aula; desde a v140; detalhe: min 30 / 60 / 120, 0 = desligado; modo antes / meio, desde a v147)',
  'resumo_agenda.preferencia': 'Mudou "Resumo da agenda" do professor (desde a v140; detalhe: quando noite / manha / desligado)',
  'custos.adicionar': 'Adicionou academia mensal',
  'custos.remover': 'Tirou academia mensal',
  'conta.excluir_pedir': 'Tocou em "Excluir minha conta" (professor)',
  // aluno
  'aluno.whatsapp_dispensar': 'Aluno dispensou o aviso de WhatsApp',
  'aluno.pix_copiar_codigo': 'Aluno copiou o código Pix',
  'aluno.pix_copiar_chave': 'Aluno copiou a chave Pix',
  'aluno.ja_paguei': 'Aluno tocou em "Já paguei"',
  'aluno.atalho_pagar': 'Aluno tocou em "Pagamento em aberto"',
  'aluno.antecipar_abrir': 'Aluno abriu "Pagar adiantado"',
  'aluno.aula_responder': 'Aluno respondeu se foi à aula (desde a v140, detalhe motivo: aconteceu / eu_nao_fui / prof_nao_veio — "o professor não veio"; ja_feito = tocou de novo no mesmo)',
  'aluno.presenca_responder': 'Aluno respondeu "Tudo certo para a aula?" (desde a v140; detalhe: resposta vou / nao_vou, origem push / folha / faixa / hoje / pendencias / push_botao = botão "Não vou" do aviso no celular (desde a v147), ja_feito, ja_mudou). nao_vou abre o aviso de falta de sempre',
  'aluno.prof_whats': 'Aluno tocou em "Chamar o professor no WhatsApp" durante a aula (desde a v140; detalhe: origem)',
  'aluno.aula_cancelada': 'Aluno cancelou aula no prazo (desde a v131 conta só o que o banco aceitou; detalhe: resultado; desde a v148, chuva = avisou chuva num acordo ao ar livre)',
  'aluno.aula_avisou_falta': 'Aluno avisou que vai faltar, fora do prazo (desde a v131 conta só o que o banco aceitou)',
  'aluno.reagendar_enviar': 'Aluno pediu reagendamento',
  'aluno.propor_aula_abrir': 'Aluno abriu "aula combinada"',
  'aluno.propor_aula_enviar': 'Aluno lançou aula combinada',
  'aluno.pausa_abrir': 'Aluno abriu "vou viajar"',
  'aluno.pausa_enviar': 'Aluno pediu pausa',
  'aluno.pedido_retirar': 'Aluno retirou um pedido',
  'aluno.contestar': 'Aluno contestou aula fechada',
  'aluno.contraproposta': 'Aluno respondeu a contraproposta (desde a v131 conta só o que o banco aceitou)',
  'aluno.remarcacao_responder': 'Aluno respondeu à remarcação do professor (desde a v136; detalhe: resposta ok / nao_consigo, origem inicio / pendencias, com_msg, ja_feito, ja_mudou)',
  'aluno.aviso_aula_abrir': 'Aluno abriu uma aula pelo aviso no celular (lembrete de aula; detalhe acao nao_vou = veio do botão "Não vou" do aviso, desde a v147)',
  'aluno.acordo_aceitar': 'Aluno aceitou o acordo',
  'aluno.acordo_ver_depois': 'Aluno com dois professores: na tela do acordo, "Ver depois — ir para <outro professor>" (desde a v147)',
  'aluno.acordo_outro_abrir': 'Aluno: abriu pelo Início o acordo do outro professor que espera a resposta dele (desde a v147)',
  'aluno.cancelar_pedido_abrir': 'Aluno: tocou em "Cancelar pedido" no cartão "Esperando <professor> conferir" (desde a v147)',
  'aluno.cancelou_pedido': 'Aluno cancelou o pedido que mandou a um professor (desde a v147; detalhe: aberto = o professor já tinha aberto o link, apagou = a ficha provisória saiu)',
  'aluno.acordo_ajuste_abrir': 'Aluno abriu "tem algo errado"',
  'aluno.acordo_ajuste_enviar': 'Aluno pediu correção do acordo',
  'aluno.reajuste': 'Aluno respondeu ao reajuste',
  'aluno.trocar_professor': 'Aluno trocou de professor',
  'aluno.add_prof_abrir': 'Aluno abriu "Adicionar professor" (sem detalhe: chip do topo; origem bem_vindo: botão "Cadastrar meu professor" da tela de boas-vindas, desde a v140)',
  'aluno.aula_extra_atalho': 'Aluno — Início: tocou em "Marcar aula extra" (atalho abaixo da próxima aula)',
  'aluno.add_prof_modalidade_outra': 'Aluno — "Adicionar professor": tocou em "Outra…" para digitar a modalidade',
  'aluno.add_prof_entrada': 'Aluno — "Adicionar professor": escolheu como pôr o professor (desde a v140; detalhe: via agenda / digitar / agenda_depois). Mesmo desenho do novo_aluno.entrada do professor',
  'aluno.add_prof_horario_por_dia': 'Aluno — "Adicionar professor": treina em horários diferentes por dia (desde a v140; detalhe: dias = quantos dias marcados). O convite leva um horário por dia',
  'aluno.add_prof_mesmo_horario': 'Aluno — "Adicionar professor": voltou para o mesmo horário em todos os dias (desde a v140)',
  'aluno.add_prof_nao_sei': 'Aluno — "Adicionar professor": tocou em "Não sei — ele preenche" (desde a v143; detalhe: passo quanto / comecou / pagou)',
  'aluno.add_prof_mudar': 'Aluno — "Adicionar professor": tocou numa linha da Confira para mudar (desde a v143; detalhe: passo)',
  'aluno.add_prof_prazo_desmarcar': 'Aluno — "Adicionar professor": "Combinaram prazo para desmarcar?" (desde a v147; detalhe: h = 0 livre, ou as horas)',
  'aluno.convidar_prof_abrir': 'Aluno abriu "Convidar professor" no Início (detalhe: origem pendente / sem_prof / outro; desde a v140 as três abrem o mesmo assistente do "Adicionar professor")',
  'aluno.convidar_prof_gerar': 'Aluno gerou link para o professor',
  'aluno.convite_prof_copiar': 'Aluno copiou o link para o professor',
  'aluno.convite_prof_contatos': 'Aluno buscou o professor nos contatos (tela de boas-vindas, só até a v139; desde a v140 a agenda fica dentro do assistente: aluno.add_prof_entrada)',
  'aluno.prof_novo_aceitar': 'Aluno aceitou professor novo',
  'aluno.prof_novo_recusar': 'Aluno recusou professor novo',
  'aluno.usar_sem_professor': 'Aluno quis usar sem professor',
  'aluno.convite_aceitar': 'Aluno aceitou o convite',
  'aluno.convite_escolheu_ficha': 'Aluno escolheu a ficha no convite',
  'aluno.perfil_salvar': 'Aluno salvou o perfil',
  'aluno.excluir_conta_abrir': 'Aluno tocou em "Excluir minha conta"',
};

// Validacoes que barraram a pessoa FORA de um funil (aviso.bloqueio com fluxo e sem
// fluxo_inst). Nao sao funis: o painel mostra como "travas" com nome legivel.
export const VALIDACOES_SOLTAS = {
  login: 'Entrar',
  senha_recuperar: 'Recuperar senha',
  senha_redefinir: 'Criar nova senha',
  pedido_prof: 'Professor aceitando pedido do aluno',
  pedido_responder: 'Responder pedido do aluno',
  reposicao_marcar: 'Marcar reposição',
  aula_avulsa: 'Aula avulsa',
  aula_reagendar: 'Reagendar aula',
  aula_cancelar_prof: 'Professor cancelando aula',
  aula_desfazer: 'Professor desfazendo o registro de uma aula',
  aula_marcar: 'Professor marcando aula dada/falta',
  aviso_aluno_registrar: 'Professor registrando o aviso do aluno',
  aviso_aluno_decidir: 'Professor decidindo aviso fora do prazo',
  pausa_pacote: 'Professor pausando as aulas a pedido do aluno',
  proposta_aula: 'Professor confirmando aula lançada pelo aluno',
  agenda_gerar: 'Gerar aulas',
  agenda_horario_fixo: 'Mudar horário fixo',
  reajuste_aluno: 'Reajuste (aluno)',
  reajuste_financeiro: 'Reajuste (financeiro)',
  financeiro_exportar: 'Exportar relatório',
  perfil_salvar: 'Salvar perfil',
  custos_mensais: 'Academia mensal',
  turma_preco: 'Valor na turma',
  turma_editar: 'Editar turma',
  convite_turma: 'Convite da turma',
  aluno_cancelar: 'Aluno cancelando aula',
  aluno_avisar_falta: 'Aluno avisando falta',
  aluno_reagendar: 'Aluno pedindo reagendamento',
  aluno_propor_aula: 'Aluno lançando aula',
  aluno_pausa: 'Aluno pedindo pausa',
  pagamento_cancelar: 'Cancelar lançamento',
  pagamento_reabrir: 'Reabrir cobrança (lista desatualizada)',
  ficha_pagamento: 'Ficha do aluno — salvar pagamento',
  aluno_acordo: 'Aluno confirmando o acordo',
  aluno_reajuste: 'Aluno respondendo ao reajuste',
  aluno_ja_paguei: 'Aluno avisando "Já paguei"',
  aluno_contraproposta: 'Aluno respondendo ao novo horário do professor',
  aluno_remarcacao: 'Aluno respondendo à remarcação do professor (Ok / Não consigo)',
  remarcacao_recusada: 'Professor abrindo uma aula que o aluno disse que não consegue (aula_mudou = já estava em outro horário; desde a v136)',
  aluno_presenca: 'Aluno respondendo "Vou" à pergunta do professor (desde a v140; sem_funcao = banco sem o SQL da v140)',
  indicacao: 'Professor entrando pelo convite de outro professor (desde a v147: convite_invalido, muitas_tentativas, sem_permissao)',
  convite_prof: 'Professor gerando o link de convite para professores (desde a v147: sem_permissao, tente_de_novo, sem_resposta)',
  aluno_aula_responder: 'Aluno dizendo o que aconteceu na aula (desde a v140: aula_nao_comecou, cedo_demais = "professor não veio" antes de 15 min, tarde_demais = depois de 7 dias, avisou_falta, turma, aula_mudou = já desmarcada/fechada, sem_funcao)',
};

function semAcao(c) { return String(c || '').replace(/^acao\./, ''); }
export function rotuloTela(c) { return TELAS_CONHECIDAS[c] || c; }
export function rotuloAcao(c) { return ACOES_CONHECIDAS[semAcao(c)] || semAcao(c); }
export function rotuloJanela(c) { return JANELAS_CONHECIDAS[c] || c; }
export function rotuloFluxo(c) { return (FLUXOS[c] && FLUXOS[c].rotulo) || VALIDACOES_SOLTAS[c] || c; }
export function rotuloPasso(fluxo, passo) {
  const f = FLUXOS[fluxo];
  return (f && f.passos && f.passos[passo]) || ('Passo ' + passo);
}
